import React, { useContext } from "react";
import AccordionContext from "react-bootstrap/AccordionContext";

// Down arrow for a side-menu Accordion.Toggle; flips up while its section is open.
const AccordionArrow = ({ eventKey }) => {
  const activeKey = useContext(AccordionContext);
  const isOpen = activeKey != null && String(activeKey) === String(eventKey);

  return (
    <i
      className="fal fa-angle-down"
      aria-hidden="true"
      style={{
        float: "right",
        marginTop: "3px",
        transition: "transform 0.2s",
        transform: isOpen ? "rotate(180deg)" : "none",
      }}
    />
  );
};

export default AccordionArrow;
